<template>
  <div>
    <v-overlay :value="isLoading"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
    <!-- MENU CONTAINER SECTION BACKGROUND -->
    <div class="menu_container_section_background">
      <div class="col-md-12 menu_container_section_container">
        <div v-for="(menu, index) in itensMenuFuncionario" :key="index" class="menu_container_section_"
          @click="handleClick(menu)">
          <div v-if="menu.novo == 1" class="novo-badge-item-menu">Novo</div>
          <figure class="menu_container_section_img">
            <img :src="menu.icon" />
          </figure>
          <div class="menu_container_section_text_container">
            <span class="menu_container_section_text_title">{{ menu.descricao }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
const ls = require('local-storage')
import ItensMenuUtilitarios from '@/utilitarios/ItensMenuUtilitarios';
export default {
  data: () => ({
    itensMenuFuncionario: [],
    isLoading: false,
    temAcessoInstituicao: true
  }),

  computed: {
    islicencaExpirada() {
      return ls.get('licencaExpirada')
    }
  },

  async created() {
    this.isLoading = true;
    try {
      this.$store.state.idclasse = null
      this.itensMenuFuncionario = await ItensMenuUtilitarios.getItensByMenu(4);
    } catch (error) {
      Swal.fire(
        'Informação',
        'Erro ao carregar a página!',
        'error'
      );

    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    async handleClick(menu) {
      // 1️⃣ Validação de licença
      if (menu.validarLicenca === 1 && this.isLicencaExpirada === 1) {
        Swal.fire(
          'Informação',
          'A sua licença de utilização está expirada! Por favor, entre em contato com o administrador do sistema.',
          'info'
        );
        return;
      }

      // 2️⃣ Validação de acesso da instituição
      if (menu.validarInstituicao == 1) {
        const verificacao = await ItensMenuService.getAcessoMenuInstituicao(menu.id);
        this.temAcessoInstituicao = verificacao.length > 0;
      }

      if (!this.temAcessoInstituicao) {
        Swal.fire(
          'Acesso Negado',
          'A sua instituição não possui permissão para acessar esta funcionalidade. Entre em contato com os administradores do sistema para mais informações.',
          'info'
        );
        this.temAcessoInstituicao = true;
        return;
      }

      // 3️⃣ Ação final: Navegar ou executar função
      if (menu.isRota === 1) {
        this.$router.push(menu.url);
      } else if (menu.funcao) {
        eval(menu.funcao);
      }
    },
  }
}
</script>


